import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from '../modules/auth/components';
import {PackDownloadComponent} from '../modules/data-pack/components/pack-download/pack-download.component';
import {LayoutAppComponent, LayoutLoginComponent} from '../modules/layouts/components';
import {LayoutDownloadComponent} from '../modules/layouts/components/layout-download/layout-download.component';
import {LoggedInGuard} from '../core/guards/logged-in.guard';

const routes: Routes = [
  {
    path: '', component: LayoutLoginComponent,
    children: [
      {path: '', component: LoginComponent}
    ]
  },
  {
    path: 'pack-download', component: LayoutDownloadComponent, children: [
      {path: '', canActivate: [LoggedInGuard], component: PackDownloadComponent}
    ]
  },
  {
    path: '',
    component: LayoutAppComponent,
    loadChildren: () => import('../modules/pages/pages-routing.module').then(m => m.PagesRoutingModule)
  },
  {
    path: 'auth',
    component: LayoutLoginComponent,
    loadChildren: () => import('../modules/auth/auth-routing.module').then(m => m.AuthRoutingModule)
  },
  {
    path: 'collections',
    component: LayoutAppComponent,
    loadChildren: () => import('../modules/collections/collections-routing.module').then(m => m.CollectionsRoutingModule)
  },
  {
    path: 'search',
    component: LayoutAppComponent,
    loadChildren: () => import('../modules/search-filter/search-filter-routing.module').then(m => m.SearchFilterRoutingModule)
  },
  {path: '**', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
